import React, { useEffect, useState } from "react";
import axios from "axios";

function LeagueMatchSchedule() {
  //League Matches
  const [fileLeagueMatches, setFileLeagueMatches] = useState(null);
  const [showMessageLeagueMatches, setShowMessageLeagueMatches] = useState("");
  //check
  // const [leagueMatchesPresent, setLeagueMatchesPresent] = useState(false);
  const [delteAll, setdelteAll] = useState(false);
  const [showUploadLeagueMatches, setShowUploadLeagueMatches] = useState(false);
  const [showMessageDeleteLeagueMatches, setShowMessageDeleteLeagueMatches] =
    useState("");
  const [leagueScheduleUploaded, setLeagueScheduleUploaded] = useState(false);

  //Check if Admin uploaded : (Team and players)
  useEffect(() => {
    // console.log(teamName);
    getLeagueMatchData();
  }, []);

  const CheckData = (leagueMatchesPresent) => {
    if (leagueMatchesPresent) {
      console.log("in 1");
      setdelteAll(true);
    } else if (!leagueMatchesPresent) {
      setShowUploadLeagueMatches(true);
      console.log("in 2");
    }
  };
  const getLeagueMatchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/api/match?limit=1000`
      );
      console.log(response.data.matches.length);
      if (response.data.matches.length) {
        const leagueMatchesPresent = true;
        CheckData(leagueMatchesPresent);
        // setLeagueMatchesPresent(true);
      } else {
        console.log("League Matches not set");
        const leagueMatchesPresent = false;
        CheckData(leagueMatchesPresent);
      }
      console.log(response.data);
    } catch (error) {
      console.error("Axios error:", error);
    }
  };

  const deleteAllDataFunc = () => {
    deleteTeamData(`${process.env.REACT_APP_SERVER_URL}/api/match`);
  };
  //Delete Data-----------------------------------------
  async function deleteTeamData(url) {
    try {
      const response = await axios.delete(url);
      console.log("DELETE League Matches request successful");
      console.log(response.data); // Handle the response data
      setShowMessageDeleteLeagueMatches(response.data);
      setShowUploadLeagueMatches(true);
    } catch (error) {
      console.error("Error making  DELETE League Matches request:", error);
      // Handle errors
    }
  }

  // ------------------------------------------Delete Data
  ///Team ------------------------------------------------------
  const handleFileChangeLeagueMatches = (e) => {
    if (e.target.files) {
      const selectedFile = e.target.files[0];
      if (selectedFile.type === "text/csv") {
        setFileLeagueMatches(selectedFile);
      } else {
        alert("Please select a CSV file.");
      }
    }
  };

  const handleUploadLeagueMatches = (e) => {
    e.preventDefault();
    console.log("clicked League match");
    if (!fileLeagueMatches) {
      return;
    }
    //TeamData
    uploadLeagueMatches();
  };

  const uploadLeagueMatches = async () => {
    const formLeagueMatches = new FormData();
    formLeagueMatches.append("file", fileLeagueMatches);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/match`,
        formLeagueMatches
      );
      if (response.data.message) {
        // Display the message on the screen
        setShowMessageLeagueMatches(response.data.message);
        funcWithTwoSecondsDelay();
      }
    } catch (error) {
      console.error("Axios error:", error);
      alert("Axios error:", error);
    }
  };
  function funcWithTwoSecondsDelay() {
    setTimeout(() => {
      setLeagueScheduleUploaded(true);
    }, 2000); // 2000 milliseconds = 2 seconds
  }
  //
  // ------------------------------------------------------Match

  const [showDetails, setShowDetails] = useState(false);
  return (
    <>
      <li className="flex w-full py-5">
        <details className="group w-full">
          <summary className="flex items-center justify-between gap-2 p-2 font-medium marker:content-none hover:cursor-pointer">
            <div
              className="flex justify-between w-full"
              onClick={() => setShowDetails(true)}
            >
              <div className="flex gap-5">
                <div className="min-w-0 flex-auto">
                  <p className="text-xl sm:text-2xl md:text-4xl font-semibold leading-6  text-indigo-600">
                    Changes in League Match Schedule?
                  </p>
                </div>
              </div>
            </div>
            <svg
              className="w-5 h-5 text-gray-500 transition group-open:rotate-90 self-center"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              ></path>
            </svg>
          </summary>
          <div className=" mx-auto max-w-[650px] bg-white ">
            {/* <div className="mb-5">
              <p className="mt-6 text-xl leading-8 text-slate-800 font-bold text-center">
                Not sure if you have already uploaded League Schedule ?
              </p>
            </div>

            <div className="mb-6 pt-4">
              <div className="mb-8">
                <div className="relative flex min-h-[200px] items-center justify-center rounded-md border border-dashed border-[#e0e0e0] m-8 text-center">
                  <button
                    className={`hover:shadow-form w-[70%] rounded-md py-3 px-8 text-center text-base font-semibold text-white outline-none bg-[#117C13]
                            }`}
                    // className="hover:shadow-form w-full rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
                    onClick={CheckData}
                  >
                    Check
                  </button>
                </div>
              </div>
            </div> */}
            {/* {delteAll && fileLeagueMatches === null ? ( */}
            {delteAll && fileLeagueMatches === null ? (
              <div className="flex justify-center m-5 sm:m-0 ">
                <div className="flex flex-col">
                  <p className="mt-6 text-xl leading-8 mb-5">
                    Data already Exists , click on button below to delete
                  </p>
                  <button
                    className={`hover:shadow-form  rounded-md py-3 px-8 text-center text-base font-semibold text-white outline-none ${
                      showMessageDeleteLeagueMatches
                        ? "bg-red-800"
                        : "bg-[#6A64F1]"
                    }`}
                    // className="hover:shadow-form w-full rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
                    onClick={deleteAllDataFunc}
                  >
                    {showMessageDeleteLeagueMatches.length < 1
                      ? "Delete"
                      : "Deleted"}
                  </button>
                </div>
              </div>
            ) : (
              <></>
            )}
            {/* <p className="mt-6 text-xl leading-8 text-green-800 font-semibold text-center">
                  Please Enter League Match Schedule
                </p> */}
            {!showMessageLeagueMatches && showMessageDeleteLeagueMatches ? (
              <p className="mt-6 text-xl leading-8 text-green-800 font-semibold text-center">
                Please Enter League Match Schedule
              </p>
            ) : (
              <></>
            )}
            {leagueScheduleUploaded ? (
              <p className="mt-6 text-xl leading-8 text-green-800 font-semibold text-center">
                League Match data uploaded
              </p>
            ) : (
              <></>
            )}
            {showUploadLeagueMatches && !leagueScheduleUploaded ? (
              <form className="py-4 px-9">
                <div className="mb-5">
                  <p className="mt-6 text-xl leading-8 text-slate-800 font-bold text-center">
                    Submit this to Schedule League Matches
                  </p>
                </div>

                <div className="mb-6 pt-4">
                  <label className="mb-5 block text-xl font-semibold text-[#07074D]">
                    Upload File
                  </label>

                  <div className="mb-8">
                    <input
                      type="file"
                      name="fileLeagueMatches"
                      id="fileLeagueMatches"
                      className="sr-only"
                      accept=".csv"
                      onChange={handleFileChangeLeagueMatches}
                    />
                    <label
                      htmlFor="fileLeagueMatches"
                      className="relative flex min-h-[200px] items-center justify-center rounded-md border border-dashed border-[#e0e0e0] p-12 text-center"
                    >
                      <div>
                        <span className="mb-2 block text-xl font-semibold text-[#07074D]">
                          Drop files here
                        </span>
                        <span className="mb-2 block text-base font-medium text-[#6B7280]">
                          Or
                        </span>
                        <span className="inline-flex rounded border border-[#e0e0e0] py-2 px-7 text-base font-medium text-[#07074D]">
                          Browse
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="mb-5 rounded-md bg-[#F5F7FB] py-4 px-8">
                    <div className="flex items-center justify-between">
                      <span className="truncate pr-3 text-base font-medium text-[#07074D]">
                        <div className="mt-2">
                          {fileLeagueMatches &&
                            `${fileLeagueMatches.name} -  ${fileLeagueMatches.type}`}
                        </div>
                      </span>
                      {!showMessageLeagueMatches ? (
                        <button className="text-[#07074D]">
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M0.279337 0.279338C0.651787 -0.0931121 1.25565 -0.0931121 1.6281 0.279338L9.72066 8.3719C10.0931 8.74435 10.0931 9.34821 9.72066 9.72066C9.34821 10.0931 8.74435 10.0931 8.3719 9.72066L0.279337 1.6281C-0.0931125 1.25565 -0.0931125 0.651788 0.279337 0.279338Z"
                              fill="currentColor"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M0.279337 9.72066C-0.0931125 9.34821 -0.0931125 8.74435 0.279337 8.3719L8.3719 0.279338C8.74435 -0.0931127 9.34821 -0.0931123 9.72066 0.279338C10.0931 0.651787 10.0931 1.25565 9.72066 1.6281L1.6281 9.72066C1.25565 10.0931 0.651787 10.0931 0.279337 9.72066Z"
                              fill="currentColor"
                            />
                          </svg>
                        </button>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>

                <div>
                  <button
                    className={`hover:shadow-form w-full rounded-md py-3 px-8 text-center text-base font-semibold text-white outline-none ${
                      showMessageLeagueMatches ? "bg-[#117C13]" : "bg-[#6A64F1]"
                    }`}
                    // className="hover:shadow-form w-full rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
                    onClick={handleUploadLeagueMatches}
                  >
                    {!showMessageLeagueMatches ? "Send" : "Sent"}
                  </button>
                </div>
                <div className="flex m-4 justify-center">
                  {/* <button className="hover:shadow-form w-full rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none">
       extra
     </button> */}
                  <p className="mb-4 text-xl font-bold text-green-500">
                    {showMessageLeagueMatches}
                  </p>
                </div>
              </form>
            ) : (
              <></>
            )}
          </div>
        </details>
      </li>
    </>
  );
}

export default LeagueMatchSchedule;
